"use client";

import { ExternalLink } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/lib/LanguageContext';

const HeroSection = () => {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();

  return (
    <div className="relative h-screen flex items-center overflow-hidden" id="hero">
      <motion.div 
        className="absolute inset-0 z-0"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        <div 
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1501339847302-ac426a4a7cbb?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1920&q=80')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "brightness(0.7)"
          }}
        />
      </motion.div>

      <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent z-10"></div>

      <div className="container max-w-6xl mx-auto px-6 relative z-20">
        <motion.div 
          className="flex items-center mb-8"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={t("hero.image_src")} alt="Logo" />
        </motion.div>
          
        <motion.div 
          className="flex items-center justify-between mt-8"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="text-white text-lg space-x-2">
            <button 
              className={`hover:text-brand-orange transition-colors ${language === 'en' ? 'text-brand-orange' : ''}`}
              onClick={() => setLanguage('en')}
            >
              Eng
            </button>
            <span>|</span>
            <button 
              className={`hover:text-brand-orange transition-colors ${language === 'pt' ? 'text-brand-orange' : ''}`}
              onClick={() => setLanguage('pt')}
            >
              Por
            </button>
          </div>
          <motion.button 
            className="flex items-center text-white hover:text-brand-orange transition-colors"
            whileHover={{ x: 5 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => document.getElementById("video")?.scrollIntoView({ behavior: "smooth" })}
          >
            {t('hero.watch_video')} <ExternalLink className="ml-2 h-4 w-4" />
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};

export default HeroSection;
